<template>
  <div class="containerTable">
    <vxe-toolbar
      id="toolbarId_st7"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button
          v-if="getLimit('Authorization_search_button')"
          @click="funcFilter()"
          >查询</el-button
        >
        <el-button
          v-if="getLimit('Authorization_export_button')"
          @click="funcExport()"
          >导出</el-button
        >
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      resizable
      border
      stripe
      highlight-current-row
      show-footer
      highlight-hover-row
      :loading="loading"
      height="80%"
      :data="tableData"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column>
        <vxe-table-column
          field="name"
          title="实际承运人姓名"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.name"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="phone"
          title="手机号"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.phone"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="identificationNumber"
          title="身份证号"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.identificationNumber"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="gmtCreated" title="创建时间" min-width="120" />
      </vxe-table-column>
      <vxe-table-column title="操作" width="50" fixed="right">
        <template slot-scope="scope">
          <el-tooltip
            v-if="getLimit('Authorization_print_button')"
            class="item"
            effect="dark"
            content="打印"
            placement="top"
          >
            <vxe-button type="text" @click="Printing(scope.row.code)">
              <i class="el-icon-printer" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-sizes="Pagingconf"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import { getDriverTeamListAuth } from "@/api/driver";
export default {
  data() {
    return {
      loading: false,
      modelDetailFlag: false,
      tableData: [],
      balanceGmtModifiedRange: "",
      exportObj: {
        exportUrl: "/ntocc-basic-api/driver/exportTaxAuthDriver", //导出接口
        name: "授权委托"
      },
      listQuery: {
        pageNum: 1,
        pageSize: 20,
        total: 0,
        authStatus: 3,
        driverType: 4
      }
    };
  },
  created() {
    this.findList();
  },
  methods: {
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        getDriverTeamListAuth(this.listQuery).then(response => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          this.loading = false;
          resolve();
        });
      });
    },
    //打印
    Printing(code) {
      this.$router.push({
        path: "/addedService/Taxation/Printing",
        query: {
          driverCode: code
        }
      });
    }
  }
};
</script>
<style></style>
